import React, { useEffect, useRef } from "react";

// Animated LED VU meter reading a channel's live level.
export default function VUMeter({ channel, segments = 16, height = 150 }) {
  const ref = useRef(null);
  const raf = useRef(null);

  useEffect(() => {
    const leds = ref.current ? Array.from(ref.current.children) : [];
    const tick = () => {
      const level = channel && channel.getLevel ? channel.getLevel() : 0;
      const active = Math.round(level * segments);
      leds.forEach((led, i) => {
        const idx = i; // bottom-up (flex-col-reverse)
        if (idx < active) {
          let color = "#00ff66";
          if (idx > segments * 0.85) color = "#ff3333";
          else if (idx > segments * 0.65) color = "#ffb800";
          led.style.background = color;
          led.style.boxShadow = `0 0 4px ${color}`;
        } else {
          led.style.background = "#1c1c1c";
          led.style.boxShadow = "none";
        }
      });
      raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [channel, segments]);

  return (
    <div
      ref={ref}
      className="flex flex-col-reverse gap-[2px] bg-black p-[2px] rounded-sm"
      style={{ width: 8, height }}
    >
      {Array.from({ length: segments }).map((_, i) => (
        <div key={i} className="w-full flex-1 rounded-[1px]" style={{ background: "#1c1c1c" }} />
      ))}
    </div>
  );
}
